<ng-content select="[slot='start']"></ng-content>
<div class="mr-auto w-full">
  <ng-content></ng-content>
</div>
<ng-content select="[slot='end']"></ng-content>
